import axios from "axios";


export interface BannerItem {
    status: "published" | "draft";
    image: string;
    description: string;
}

export interface BannerResponse {
    data: BannerItem[];
}

export interface HomeBanner {
    url: string;
    description: string;
}

const API_URL = `${process.env.PROXY_URL}/api/${process.env.CMS_PROXY_PATH}`;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const transformResponseToBanner = (banner: BannerItem) => ({
    url: banner.image ? `${API_URL}/assets/${banner.image}` : '',
    description: banner.description,
})

export async function getHomeBanners(): Promise<HomeBanner[]> {
  const response = await axiosInstance.get<BannerResponse>(
    `/items/banner_images?filter[status][_eq]=published`
  );
  const { data } = response.data;
  const banners = data && Array.isArray(data) ? data.map(transformResponseToBanner) : [];
  return banners;
}